// extracted by mini-css-extract-plugin
export default {"text":"TextComponent_text__Rxjgr","mainDiv":"TextComponent_mainDiv__enGTT","backIconDiv":"TextComponent_backIconDiv__HTD1T","Container":"TextComponent_Container__brhUt"};